import config from '@/config'

export default ($axios) => {
    return {
        getUserList(p, limit, queryParams = {}) {
            const data = {
                p: p,
                limit: limit,
                queryParams: queryParams,
                action: '/user/get-user-list'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
        addUserInfo(param = {}) {
            const data = {
                param: param,
                action: '/user/add-user'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
        changePwd(id, pwd) {
            const data = {
                id: id,
                pwd: pwd,
                action: '/user/change-pwd'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
        getGroupList(p, limit, queryParams = {}) {
            const data = {
                p: p,
                limit: limit,
                queryParams: queryParams,
                action: '/user/get-group-list'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
        addPermission(param = {}) {
            const data = {
                param: param,
                action: '/user/add-permission'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
        getPermissionList(p, limit, queryParams = {}) {
            const data = {
                p: p,
                limit: limit,
                queryParams: queryParams,
                action: '/user/get-permission-list'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
        deleteUser(id) {
            const data = {
                id: id,
                action: '/user/delete-user'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
        deletePermission(id) {
            const data = {
                id: id,
                action: '/user/delete-permission'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },

    }
}